import { IGuestInfo, StringUtils } from '@localina/core';

const formatGuestName = (guestInfo?: IGuestInfo, fallback = '') =>
    guestInfo ? StringUtils.combineStrings([guestInfo.lastName, guestInfo.firstName]) : fallback;

export const GuestUtils = {
    formatGuestName,
};
